import { Link } from 'react-router-dom';

export function SupportConsolePage() {
  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/saas" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Global SaaS Dashboard</Link>
      <h1 className="mt-2 text-2xl font-semibold">Support Console</h1>
      <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">Support mode, impersonation and tenant lock controls for platform operators.</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {['Support Mode', 'Impersonation', 'Tenant Lock', 'Maintenance Mode', 'Global Broadcast'].map((f) => (
          <div key={f} className="rounded-xl border p-4 dark:border-slate-700">
            <p className="font-medium">{f}</p>
            <p className="mt-1 text-xs text-slate-500">Audited operator action — requires admin scope</p>
          </div>
        ))}
      </div>
    </div>
  );
}
